import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ClinicStatus } from '../models/clinic-status.model';
import { ClinicStatusEndpoint } from './clinic-status-endpoint.service';
import { ErrorHandleService } from './error-handle.service';
import { AlertService, MessageSeverity } from './alert.service';

@Injectable({
  providedIn: 'root'
})

export class ClinicStatusService {

  constructor(private router: Router, private alertService: AlertService,
    private errorHandleService: ErrorHandleService, private clinicStatusEndpoint: ClinicStatusEndpoint) { }

  getClinicStatusList(): Observable<ClinicStatus[]> {
    const result: ClinicStatus[] = new Array();

    this.clinicStatusEndpoint.getClinicStatusListEndpoint<ClinicStatus[]>().subscribe(response => {
      response.forEach(status => result.push(status));
    }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "施設状況リスト取得中にエラーが発生しました。", error));

    return of(result);
  }

  getClinicStatus(id: number): Observable<ClinicStatus> {
    const result: ClinicStatus = new ClinicStatus();

    this.clinicStatusEndpoint.getClinicStatusEndpoint<ClinicStatus>(id).subscribe(response => {
      result.update(response);
    }, error => this.errorHandleService.showMessageAndRedirect("データ取得失敗", "施設状況取得中にエラーが発生しました。", error));

    return of(result);
  }

  updateStatus(clinicStatus: ClinicStatus) {
    this.clinicStatusEndpoint.updateStatusEndpoint(clinicStatus).subscribe(() => {

      this.alertService.showMessage("施設状況更新", "施設状況を更新しました。", MessageSeverity.success);
      this.router.navigate(['/clinicstatus/', clinicStatus.institutionId]);
    }, error => this.errorHandleService.showMessageAndRedirect("施設状況更新失敗", "施設状況更新中にエラーが発生しました。", error));
  }
}
